class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/uat/customer'
			},
			create: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/add/uat/customer'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/uat/customer'
			}
		};
	}
}

export default new APIS();
